var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 638,
    height: 196,
    viewBox: "0 0 638 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2885_6072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.457 52.7432H509.388L601.281 159.204H36.7266L134.457 52.7432Z",
    fill: "#0B192E",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.126 39.082H484.972L565.079 134.708H72.9287L158.126 39.082Z",
    fill: "#0B192E",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.595 36.2559H463.854L533.769 119.634H104.238L178.595 36.2559Z",
    fill: "#0B192E",
    fillOpacity: 0.19
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2885_6072",
    x: 0.726562,
    y: 0.255859,
    width: 636.554,
    height: 194.948,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    result: "effect1_foregroundBlur_2885_6072"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow);
export default __webpack_public_path__ + "static/media/Shadow.e6e0e14c08d82c6f5d723479223213e5.svg";
export { ForwardRef as ReactComponent };